export const arrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <path d="M11.0382 7L12.5782 7L12.5782 14.448L14.5802 12.614L15.6162 13.692L11.8082 16.996L8.00021 13.692L9.03621 12.614L11.0382 14.448L11.0382 7Z" />
  </svg>
);

export const exit = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <rect
      x="15.4854"
      y="7"
      width="2"
      height="12"
      transform="rotate(45 15.4854 7)"
    />
    <rect
      x="7"
      y="8.41418"
      width="2"
      height="12"
      transform="rotate(-45 7 8.41418)"
    />
  </svg>
);

export const pin = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    aria-hidden
  >
    <path
      d="M19 10.7777C19 7.58687 16.3136 5 13 5C9.6864 5 7 7.58687 7 10.7777C7 15.4364 13 21 13 21C13 21 19 15.4364 19 10.7777Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 9C14.1046 9 15 9.89543 15 11C15 12.1046 14.1046 13 13 13C11.8954 13 11 12.1046 11 11C11 9.89543 11.8954 9 13 9Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const logo = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1400 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M128.119 38.6108C128.119 51.5234 124.94 61.6534 109.247 68.2067C127.523 73.9678 133.679 86.0853 133.679 101.776C133.679 133.359 109.645 142.496 76.8696 142.496H0V3.45361H78.2609C110.637 3.45361 128.119 13.9811 128.119 38.6108ZM57.4047 57.2826H67.7344C73.098 57.2826 74.6861 53.1116 74.6861 50.133C74.6861 47.3523 73.098 43.1794 67.7344 43.1794H57.4047V57.2826ZM57.4047 102.174H69.9197C75.4811 102.174 76.474 97.6056 76.474 94.8249C76.474 92.0442 75.4811 87.4756 69.9197 87.4756H57.4047V102.174Z" />
    <path d="M302.211 100.179V141.48C294.009 145.44 275.622 147.987 264.872 147.987C250.445 147.987 236.301 144.31 228.946 134.408C217.631 143.177 204.053 147.987 186.231 147.987C161.054 147.987 138.992 135.823 138.992 107.818C138.992 73.3073 169.261 63.4049 199.81 63.4049C205.469 63.4049 216.502 63.9705 223.573 65.385V63.9705C223.573 56.051 215.936 53.5053 198.114 53.5053C181.988 53.5053 166.148 56.0501 147.762 62.2728V11.0721C163.036 6.82957 187.365 2.01953 206.883 2.01953C258.083 2.01953 290.332 13.6188 290.332 71.3244V94.8035C290.332 98.7655 292.314 100.746 296.557 100.746C298.535 100.746 300.517 100.463 302.212 100.178L302.211 100.179ZM216.501 109.516C219.331 109.516 221.591 108.666 223.573 107.534V93.6741C221.874 93.3918 219.045 93.1085 217.349 93.1085C212.824 93.1085 208.012 95.0886 208.012 101.311C208.012 107.534 212.258 109.516 216.501 109.516Z" />
    <path d="M381.263 3.85107C412.648 3.85107 442.245 16.3642 442.245 55.4947C442.245 75.7565 435.094 88.6681 423.572 96.6127L454.957 142.895H391.59L368.75 107.34H366.564V142.895H309.357V3.85107H381.262H381.263ZM386.229 57.4823C386.229 53.509 383.844 48.3451 376.892 48.3451H366.564V66.8172H376.892C383.844 66.8172 386.229 61.6533 386.229 57.4823Z" />
    <path d="M599.778 73.3724C599.778 114.886 573.754 146.469 523.103 146.469C472.453 146.469 446.828 114.886 446.828 73.3724C446.828 31.8588 472.452 0.275391 523.102 0.275391C573.753 0.275391 599.778 31.8569 599.778 73.3724ZM508.005 73.3724C508.005 87.8731 513.371 94.8249 523.103 94.8249C533.235 94.8249 538.597 87.8731 538.597 73.3724C538.597 58.8717 533.235 51.9199 523.103 51.9199C513.371 51.9199 508.005 58.8717 508.005 73.3724Z" />
    <path d="M649.649 3.85107L687.191 50.5305C685.601 40.0012 685.601 33.2491 685.601 26.0986V3.85107H743.008V142.895H699.109L661.567 96.0174C663.157 106.743 663.157 113.497 663.157 120.647V142.895H605.75V3.85107H649.649Z" />
    <path d="M907.336 39.002C907.336 51.9145 904.158 62.0445 888.465 68.5996C906.741 74.3589 912.897 86.4764 912.897 102.167C912.897 133.752 888.862 142.889 856.087 142.889H779.217V3.84473H857.478C889.854 3.84473 907.335 14.3722 907.335 39.002H907.336ZM836.622 57.6737H846.952C852.316 57.6737 853.904 53.5027 853.904 50.5241C853.904 47.7434 852.316 43.5705 846.952 43.5705H836.622V57.6737ZM836.622 102.565H849.137C854.699 102.565 855.692 97.9967 855.692 95.216C855.692 92.4353 854.699 87.8667 849.137 87.8667H836.622V102.565Z" />
    <path d="M990.18 4.24219C1021.57 4.24219 1051.16 16.7554 1051.16 55.8877C1051.16 76.1476 1044.01 89.0592 1032.49 97.0038L1063.87 143.286H1000.51L977.667 107.731H975.481V143.286H918.274V4.24219H990.18ZM995.145 57.8734C995.145 53.9001 992.76 48.7362 985.808 48.7362H975.48V67.2083H985.808C992.76 67.2083 995.145 62.0444 995.145 57.8734Z" />
    <path d="M1208.69 73.7635C1208.69 115.279 1182.67 146.861 1132.02 146.861C1081.37 146.861 1055.74 115.279 1055.74 73.7635C1055.74 32.248 1081.37 0.666504 1132.02 0.666504C1182.67 0.666504 1208.69 32.248 1208.69 73.7635ZM1116.92 73.7635C1116.92 88.2642 1122.29 95.216 1132.02 95.216C1142.15 95.216 1147.51 88.2642 1147.51 73.7635C1147.51 59.2628 1142.15 52.3111 1132.02 52.3111C1122.29 52.3111 1116.92 59.2628 1116.92 73.7635Z" />
    <path d="M1332.66 11.5915V59.2638C1317.56 51.1195 1294.12 45.1605 1279.62 45.3584C1272.86 45.3584 1271.87 51.1195 1279.22 52.9073C1295.11 57.2781 1339.21 57.4759 1339.21 98.5939C1339.21 137.129 1307.43 146.861 1273.26 146.861C1251.21 146.861 1229.56 142.291 1213.67 133.354V84.6885C1232.34 96.011 1254.59 101.97 1267.7 101.97C1274.85 101.97 1275.45 96.011 1269.09 94.421C1253 90.2499 1212.08 85.4835 1212.08 46.7487C1212.08 15.9622 1235.33 0.666504 1272.07 0.666504C1294.72 0.666504 1316.96 4.24223 1332.66 11.5915Z" />
    <path d="M1345.97 120.84C1345.97 103.161 1358.69 94.6206 1372.79 94.6206C1387.29 94.6206 1400 103.162 1400 120.84C1400 138.32 1387.29 146.86 1372.79 146.86C1358.69 146.86 1345.97 138.319 1345.97 120.84Z" />
  </svg>
);
